module.exports = __webpack_public_path__ + "fonts/PilatExtended-Demi.woff2";